import ButtonGroup from "@/Common/Components/Buttons/ButtonGroup";
import { Modal } from "@/Common/Components/Modals/Modal";
import { useTranslation } from "@/Common/CustomHooks/useTranslation";
import { Button } from "@/DesignSystem/Molecules/Button";

import styles from "./AIScribe.module.scss";

interface ISubscriptionExpiredPopupProps {
    onClose: () => void;
    onRenewClicked: () => void;
    onUnlinkCarewayAccount: () => void;
}

function AIScribeSubscriptionExpiredPopup(props: Readonly<ISubscriptionExpiredPopupProps>): JSX.Element {
    const { getText } = useTranslation();

    function handleCheckStatusClicked(): void {
        props.onRenewClicked?.();

        const url = "https://app.coeurway.com/";
        window.open(url, "_blank", "noopener");
    }

    function handleUnlinkCareWayAccount(): void {
        props.onUnlinkCarewayAccount?.();
    }

    function renderFooter(): JSX.Element {
        return (
            <div className="flex-container flex-end">
                <ButtonGroup>
                    <Button
                        category="secondary"
                        variant="neutral"
                        label={getText("OKLabel")}
                        onClick={props.onClose}
                        dataCy="ai-scribe-subscription-expired-ok"
                    />
                    <Button
                        category="secondary"
                        variant="error"
                        label={getText("AIScribe_Unlink")}
                        onClick={handleUnlinkCareWayAccount}
                        dataCy="ai-scribe-subscription-expired-unlink"
                    />
                    <Button
                        category="primary"
                        variant="brand"
                        label={getText("AIScribe_SubscriptionExpiredPopup_RenewSubscription")}
                        onClick={handleCheckStatusClicked}
                        dataCy="ai-scribe-subscription-expired-check-status"
                    />
                </ButtonGroup>
            </div>
        );
    }

    return (
        <Modal
            fixedOverlayPosition
            showOverlay
            showX
            disableOverlayClose
            width={465}
            title={getText("AIScribe_SubscriptionExpiredPopup_Title")}
            onClose={props.onClose}
            id="ai-scribe-subscription-expired-popup"
            dataCy="ai-scribe-subscription-expired-popup"
            footer={renderFooter()}
            cssClass={styles.subscriptionExpiredPopup}
        >
            <div className={styles.body}>
                <p className={styles.firstSentence}>{getText("AIScribe_SubscriptionExpiredPopup_FirstSentence")}</p>
            </div>
        </Modal>
    );
}

export { AIScribeSubscriptionExpiredPopup };
